// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"c84c36c1","834":"0a370663","922":"42d0998f"}[chunkId] + ".chunk.js";
};